package com.arena_web.data.dto

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
data class SportProfileDto(
    val id: String,
    val userId: String,
    val sportId: String,
    val overallRating: Double,
    val position: SportPositionDto? = null,
    val club: String? = null,
    val country: String? = null,
    val ratings: List<SportProfileRatingDto>,
    val stats: SportProfileStatsDto? = null,
    val createdAt: String,
    val updatedAt: String
)

@Serializable
data class SportProfileRatingDto(
    val attribute: SportAttributeDto,
    val value: Double,
    val totalReviews: Int
)

@Serializable
data class SportProfileStatsDto(
    val matchesPlayed: Int,
    val wins: Int,
    val losses: Int,
    val draws: Int,
    val details: JsonObject
)

@Serializable
data class UpdateSportProfileRequest(
    val positionId: String? = null,
    val club: String? = null,
    val country: String? = null
)

/** Cross-sport "All" payload — mean of `overallRating` across every sport
 *  the user has been rated in (0–100, same scale as per-sport profiles),
 *  plus per-attribute means for the card-back radar. `sportsRated == 0`
 *  means nobody has voted on this user in any sport yet. */
@Serializable
data class SportProfileAggregateDto(
    val overallRating: Double,
    val sportsRated: Int,
    val attributes: List<AggregateAttributeDto> = emptyList(),
)

/** Per-attribute mean for the "All" radar — names follow the shared
 *  standardized schema; Possession and Serve arrive merged as one
 *  "Possession / Serve" 6th slot. */
@Serializable
data class AggregateAttributeDto(
    val name: String,
    val value: Double,
    val displayOrder: Int,
)

